<template>
  <svg viewBox="0 0 16 16" v-on="$listeners">
    <path
      d="M15.707.293a1 1 0 0 1 .083 1.32l-.083.094-14 14a1 1 0 0 1-1.497-1.32l.083-.094 2.448-2.45C1.061 10.43 0 8.715 0 8c0-1.314 3.582-6 8-6 1.29 0 2.508.4 3.587.997L14.293.293a1 1 0 0 1 1.414 0zm-1.422 4.839C15.359 6.285 16 7.444 16 8c0 1.314-3.582 6-8 6-.765 0-1.505-.14-2.205-.38l1.659-1.657a4 4 0 0 0 4.51-4.51l2.32-2.321zM8 4a4 4 0 0 0-3.447 6.031l1.514-1.514a2.003 2.003 0 0 1 2.45-2.45l1.514-1.514A3.981 3.981 0 0 0 8 4z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'password-hide',
}
</script>